import ReservationDetail from "../../../model/ReservationDetail";
import { axiosUtils } from "../../../network/axiosUtils";
import httpRequest from "../../../network/httpRequest";
import speedMateHttpRequest from "../../../network/speedMateHttpRequest";
import { HttpResponse } from "../../../network/types";

export const fetchReservationDetail = async (
  orderNo: string
): Promise<ReservationDetail> => {
  const url = `/repair-shop/tire-repair-orders/${orderNo}`;
  const response: HttpResponse = await httpRequest({
    method: axiosUtils.GET,
    url: `${url}`,
  });

  return response?.data?.row;
};
export const fetchOrderMemo = async (id: number) => {
  const url = `/repair-shop/order-memos/${id}`;
  const response = await httpRequest({ method: axiosUtils.GET, url: `${url}` });

  return response?.data.row;
};
export const sfetchReservationDetail = async (
  orderNo: string
): Promise<ReservationDetail> => {
  const url = `/repair-shop/tire-repair-orders/${orderNo}`;
  const response: HttpResponse = await speedMateHttpRequest({
    method: axiosUtils.GET,
    url: `${url}`,
  });

  return response?.data?.row;
};
export const sfetchManagerReservationDetail = async (
  orderNo: string
): Promise<ReservationDetail> => {
  const url = `/repair-shop-manager/tire-repair-orders/${orderNo}`;
  const response: HttpResponse = await speedMateHttpRequest({
    method: axiosUtils.GET,
    url: `${url}`,
  });

  return response?.data?.row;
};
export const sfetchOrderMemo = async (id: number) => {
  const url = `/repair-shop/order-memos/${id}`;
  const respons = await httpRequest({ method: axiosUtils.GET, url: `${url}` });
  return respons?.data.row;
};
